export const environment = {
  production: true,
  apiUrl: "https://umyoentertainment.site/api_umyocards/public/api/"
};


